import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "19",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000",
  d: "M13.131 2.977s.538.527 0 0A4.516 4.516 0 0 1 12.012 0H8.751v13.089a2.736 2.736 0 0 1-2.734 2.639 2.753 2.753 0 0 1-2.745-2.745c0-1.815 1.752-3.177 3.557-2.617V7.03C3.188 6.544 0 9.373 0 12.983 0 16.498 2.913 19 6.006 19a6.012 6.012 0 0 0 6.006-6.017v-6.64a7.758 7.758 0 0 0 4.54 1.458V4.539s-1.985.095-3.42-1.562Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }